import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { CenterOnPage } from "../core/CenterOnPage";
import { Features } from "../games/features.js";
import { EulaDialog } from "./EulaDialog.js";
import { useEulaGateState } from "./useEulaGateState.js";

/**
 * @param {object} props
 * @param {import("react").ReactNode} props.children
 */
const EulaGateInner = ({ children }) => {
  const { status, latestVersion } = useEulaGateState();
  const [hasAcceptedLocally, setHasAcceptedLocally] = useState(false);

  if (status === "loading") {
    return (
      <CenterOnPage>
        <CircularProgress />
      </CenterOnPage>
    );
  }

  if (status === "required" && latestVersion && !hasAcceptedLocally) {
    return <EulaDialog eulaVersion={latestVersion} onAccepted={() => setHasAcceptedLocally(true)} />;
  }

  return children;
};

/**
 * @param {object} props
 * @param {import("react").ReactNode} props.children
 */
export const EulaGate = ({ children }) => {
  if (!Features.Eula) {
    return children;
  }

  return <EulaGateInner>{children}</EulaGateInner>;
};
